import React, { useEffect, useState } from 'react';
import { TimerIcon } from 'lucide-react';
const TOTAL_SECONDS = 22 * 60 + 22;
function useCountdown(initialSeconds: number) {
  const [seconds, setSeconds] = useState(initialSeconds);
  useEffect(() => {
    const id = setInterval(() => setSeconds(s => s > 0 ? s - 1 : 0), 1000);
    return () => clearInterval(id);
  }, []);
  return {
    mm: Math.floor(seconds / 60),
    ss: seconds % 60
  };
}
function Unit({
  value,
  label
}: {
  value: number;
  label: string;
}) {
  return <span className="inline-flex items-baseline gap-1" data-id="element-149" data-mp="k294no01quwl">
      <span className="font-display text-2xl font-extrabold tabular-nums leading-none" data-id="element-150" data-mp="k429cxr3n51y">
        {String(value).padStart(2, '0')}
      </span>
      <span className="text-[10px] font-semibold uppercase tracking-wider text-white/55" data-id="element-151" data-mp="abei0iiw1tam">{label}</span>
    </span>;
}
export function OfferBar() {
  const {
    mm,
    ss
  } = useCountdown(TOTAL_SECONDS);
  return <div role="region" aria-label="Compte à rebours de l'offre" className="fixed inset-x-0 top-0 z-50 border-b border-white/10 bg-obsidian text-white" data-id="element-152" data-mp="1agc1uow3bpe">
      <div className="mx-auto flex h-11 max-w-6xl items-center justify-center gap-3 px-4 sm:gap-5" data-id="element-153" data-mp="my9ldm2o2x00">
        <p className="flex items-center gap-1.5 whitespace-nowrap text-[11px] font-bold uppercase tracking-[0.16em] text-ember sm:text-xs" data-id="element-154" data-mp="10y1605novbmz">
          <TimerIcon className="h-4 w-4 shrink-0" aria-hidden="true" data-id="element-155" data-mp="vyy06izvx1dy" />
          L'offre se termine dans :
        </p>
        <p className="flex items-baseline gap-1.5" aria-live="off" data-id="element-156" data-mp="86rb84whnwok">
          <Unit value={mm} label="Min" data-id="element-157" data-mp="3b251ipyrhja" />
          <span className="font-display text-xl font-bold text-white/40" data-id="element-158" data-mp="37whi7wzgnpo">:</span>
          <Unit value={ss} label="S" data-id="element-159" data-mp="hzyftnjen8nl" />
        </p>
      </div>
    </div>;
}